var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDollarIconAffiliateProgram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "48px",
    height: "48px",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: 9.875,
    y1: 9.875,
    x2: 38.159,
    y2: 38.159,
    gradientUnits: "userSpaceOnUse",
    id: "color-1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#21a5ad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#087e82"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-23.04,-23.04) scale(1.18,1.18)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(5.33333,5.33333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44,24c0,11 -9,20 -20,20c-11,0 -20,-9 -20,-20c0,-11 9,-20 20,-20c11,0 20,9 20,20z",
    fill: "url(#color-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3,28.7c0,-7.2 -10.6,-5.8 -10.6,-10c0,-2.2 2.5,-2.3 3.3,-2.3c1.9,0 3.7,0.5 5.1,1.1c0.4,0.2 0.9,-0.1 0.9,-0.6v-2.1c0,-0.7 -0.3,-1.1 -0.7,-1.3c-0.9,-0.4 -2.3,-0.6 -4.3,-0.7v-2.3c0,-0.3 -0.2,-0.5 -0.5,-0.5h-1c-0.3,0 -0.5,0.2 -0.5,0.5v2.3c-3.1,0.3 -6.3,2.1 -6.3,6.2c0,7.5 10.6,6 10.6,9.9c0,1.2 -0.8,2.3 -3.3,2.3c-2.5,0 -4.8,-0.9 -6.1,-1.5c-0.4,-0.2 -0.9,0.1 -0.9,0.6v2.4c0,0.5 0.3,0.9 0.7,1c1.5,0.6 3.5,1.1 5.3,1.3v2.5c0,0.3 0.2,0.5 0.5,0.5h1c0.3,0 0.5,-0.2 0.5,-0.5v-2.5c4.7,-0.4 6.3,-3.6 6.3,-6.3z",
    fill: "#ffffff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarIconAffiliateProgram);
export default __webpack_public_path__ + "static/media/dollar-icon-affiliate-program.1828334b8475e4c3c83a7004ccfbea28.svg";
export { ForwardRef as ReactComponent };